import React from 'react';
import '../components/css/popupstyle.css';
import $ from 'jquery';
import loader from '../../src/components/css/dark/img/loader.gif';
import ConfirmPopup from '../components/Confirm';
import { userService } from '../_services';

class ConfirmDeletePopup extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            password: '',
            cpassword: '',
            btnClick: false,
            btnClick2: false,
            UserName: this.props.UserName,
            UserEmail: this.props.UserEmail,
            UserId: this.props.UserId,
            EditUserConfirmation: false,
            ConfirmPopup: false,
            ConfirmSection: false
        };
        this.handleEditTextChange1 = this.handleEditTextChange1.bind(this);
    }
    componentDidMount() {
        setTimeout(() => {
            $('.popup').addClass('mfp-ready');
            $('.popup').addClass('mfp-bg');
            $('.popup').addClass('mfp-with-anim');
        }, 5);
    }
    componentDidUpdate() {

    }
    ConfirmPopup = () => {
        if (this.state.ConfirmPopup == false) {
            try {
                let field1 = $('input[name=username]').val();
                let field2 = $('input[name=useremail]').val();
                if (field2 == '' || field2 == null || field2 == undefined || field1 == '' || field1 == null || field1 == undefined) {
                    if (field1 == '' || field1 == null || field1 == undefined) {
                        $('.username').show();
                        $('.username').text('User Name cannot be blank');
                    }
                    if (field2 == '' || field2 == null || field2 == undefined) {
                        $('.useremail').show();
                        $('.useremail').text('Enter a valid email ID');
                    }
                    return false;
                }
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                if (re.test(String(field2).toLowerCase()) == false) {
                    $('.useremail').show();
                    $('.useremail').text('Enter a valid email ID');
                }
                else {
                    this.setState({
                        ConfirmPopup: !this.state.ConfirmPopup,
                        ConfirmSection: true
                    });
                }
            }
            catch (error) {
                this.setState({ btnClick2: false });
                $('.useremail').show();
                $('.useremail').text('Whoops, something went wrong. Please try again');
            }
        }
        else {
            this.setState({
                ConfirmPopup: !this.state.ConfirmPopup,
                ConfirmSection: true
            });
        }
    }
    handleTextChange1 = e => {
        $('.password').hide();
        $('#passwordField').removeClass('errorIcon');
    }
    handleTextChange2 = e => {
        $('.re-password').hide();
        $('#confirmPasswordField').removeClass('errorIcon');
    }
    handleEditTextChange1(e) {
        $('.username').hide();
        this.setState({ UserName: e.target.value });
    }
    handleEditTextChange2 = e => {
        $('.useremail').hide();
        this.setState({ UserEmail: e.target.value });
    }
    HandleResetPWD = e => {
        let fieldValue = [];
        try {
            let field1 = $('input[name=password]').val();
            let field2 = $('input[name=confirmPassword]').val();

            $('#passwordField').removeClass('errorIcon');
            $('#confirmPasswordField').removeClass('errorIcon');

            if (field1 == '' || field1 == null || field1 == undefined) {
                $('#passwordField').addClass('errorIcon');
                $('.error-message').show();
                $('.error-message').text('New password is required');
            } else if (userService.ValidateSpace(field1)) {
                $('#passwordField').addClass('errorIcon');
                $('.error-message').show();
                $('.error-message').text('Space not acceptable');
            } else if ($('input[name=password]').val().length > 0 && $('input[name=password]').val().length < 8) {
                $('#passwordField').addClass('errorIcon');
                $('.error-message').show();
                $('.error-message').text('Password must be at least 8 characters');
            } else if (field2 == '' || field2 == null || field2 == undefined) {
                $('#confirmPasswordField').addClass('errorIcon');
                $('.error-message').show();
                $('.error-message').text('Confirm new password is required');
            } else if ($('input[name=confirmPassword]').val().length > 0 && $('input[name=confirmPassword]').val().length < 8) {
                $('#confirmPasswordField').addClass('errorIcon');
                $('.error-message').show();
                $('.error-message').text('New Password and Confirm Password must match');
            } else if ($('input[name=password]').val().length >= 8 && $('input[name=confirmPassword]').val().length >= 8) {
                if ($('input[name=password]').val() != $('input[name=confirmPassword]').val()) {
                    $('#confirmPasswordField').addClass('errorIcon');
                    $('.error-message').show();
                    $('.error-message').text('New Password and Confirm Password must match');
                } else {
                    fieldValue.push(field1);
                    fieldValue.push(field2);
                    this.setState({ btnClick: true, changedPassword: fieldValue});                    
                    this.props.closePopup();
                    this.props.openManageUser(this.props.manageUserName, this.props.manageUserEmail, this.props.manageUserId, this.props.titleText, this.props.confirmSection, this.props.manageUserPagin, this.props.manageUserSearch, fieldValue);
                }
            }
        }
        catch (error) {
            this.setState({ btnClick2: false });
            $('.useremail').show();
            $('.useremail').text('Whoops, something went wrong. Please try again');
        }
    }
    HandleEditUser = e => {
        this.setState({ btnClick2: true });
        let fieldValue = [];
        try {
            let field1 = $('input[name=username]').val();
            let field2 = $('input[name=useremail]').val();
            if (field2 == '' || field2 == null || field2 == undefined || field1 == '' || field1 == null || field1 == undefined) {
                if (field1 == '' || field1 == null || field1 == undefined) {
                    $('.username').show();
                    $('.username').text('User Name cannot be blank');
                }
                if (field2 == '' || field2 == null || field2 == undefined) {
                    $('.useremail').show();
                    $('.useremail').text('Enter a valid email ID');
                }
                return false;
            }
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (re.test(String(field2).toLowerCase()) == false) {
                $('.useremail').show();
                $('.useremail').text('Enter a valid email ID');
            }
            else {
                fieldValue.push(this.state.UserId);
                fieldValue.push(field1);
                fieldValue.push(field2);
                this.props.handleEditUser(fieldValue);
            }
        }
        catch (error) {
            this.setState({ btnClick2: false });
            $('.useremail').show();
            $('.useremail').text('Whoops, something went wrong. Please try again');
        }
    }
    managePositive = () => {
        this.props.closePopup();
        this.props.openManageUser(this.props.manageUserName, this.props.manageUserEmail, this.props.manageUserId, this.props.titleText, this.props.confirmSection, this.props.manageUserPagin, this.props.manageUserSearch, this.state.changedPassword);
    }
    handleBack = () => {
        this.props.closePopup();
       this.props.openManageUser('', '', '', '', '', this.props.manageUserPagin, this.props.manageUserSearch, this.props.changedPassword);        
    }
    render() {

        return (

            <div className='tool-section report confirmClose'>
                <div className='popup mfp-zoom-in report-section'>
                    <div className='popup_inner'>

                        {
                            this.props.ConfirmSection == true ?
                                <h1>{this.props.titleText}<button onClick={this.props.closePopup}>X</button></h1> : <h1>{this.props.titleText}<button onClick={this.handleBack}>X</button></h1>
                        }
                        {
                            this.props.ConfirmSection == true ?
                                <div className="pop-btn ungap">
                                    <button className="btn" onClick={this.props.removeFilter}>Yes</button>
                                    <button className="btn cancel" onClick={this.props.closePopup}>No</button>
                                </div> : null
                        }
                        {
                            this.props.confirmSection == 'DeleteSection' ?
                                <div>
                                    <div className="pop-btn ungap">
                                        <button className="btn" onClick={this.managePositive}>Yes</button>
                                        <button className="btn cancel" onClick={this.handleBack}>No</button>
                                        <img id="DeletePopupLoader" className="loader confirmClick" src={loader} alt="loader" />

                                    </div>
                                </div> : null
                        }
                        {
                            this.props.confirmSection == 'DashboardSection' ?
                                <div className="pop-btn ungap">
                                    <button className="btn" onClick={this.managePositive}>Confirm</button>
                                    <button className="btn cancel" onClick={this.handleBack}>Cancel</button>
                                    <img id="CreatePopupLoader" className="loader confirmClick" src={loader} alt="loader" />
                                </div> : null
                        }
                        {
                            this.props.confirmSection == 'ResendPasswordSection' ?
                                <div className="pop-btn resendPassword ungap">
                                    <div className="form-group">
                                        <label>New Password</label>
                                        <input type="password" className="form-control" id="passwordField" name="password" autocomplete="new-password" onKeyUp={this.handleTextChange1} />
                                    </div>
                                    <div className="form-group">
                                        <label>Confirm New Password</label>
                                        <input type="password" className="form-control" id="confirmPasswordField" name="confirmPassword" autocomplete="new-password" onKeyUp={this.handleTextChange2} />
                                    </div>
                                    <div className="clear"></div>
                                    <div className="form-group">
                                        <button className="btn submit" onClick={this.HandleResetPWD}>Submit</button>
                                        <button className="btn cancel" onClick={this.handleBack}>Cancel</button>
                                    </div>
                                    <div className="error-message help-block"></div>
                                    {
                                        this.state.btnClick == true ?
                                            <img className="loader confirmClick" src={loader} alt="loader" /> : null
                                    }
                                </div> : null
                        }
                        {
                            this.props.EditUserSection == true ?
                                <div className="pop-btn resendPassword ungap">
                                    <input type="text" className="form-control" name="username" value={this.state.UserName} onChange={this.handleEditTextChange1} />
                                    <div className="error-message password username"></div>
                                    <input type="text" className="form-control" name="useremail" value={this.state.UserEmail} onChange={this.handleEditTextChange2} />
                                    <div className="error-message re-password useremail"></div>
                                    <div className="clear"></div>
                                    <button className="btn" onClick={this.ConfirmPopup}>Submit</button>
                                    <button className="btn cancel" onClick={this.props.CloseEditUserPopup}>Cancel</button>
                                    {
                                        this.state.btnClick2 == true ?
                                            <img className="loader confirmClick" src={loader} alt="loader" /> : null
                                    }
                                </div> : null
                        }
                        {
                            this.state.ConfirmPopup ?
                                <ConfirmPopup titleText="Confirm Popup" ConfirmSection={this.state.ConfirmSection} handleEditUser={this.HandleEditUser} CloseConfirmPopup={this.ConfirmPopup} /> : null
                        }
                    </div>
                </div>
            </div>

        )
    }
}

export default ConfirmDeletePopup;